var map = {
	"./quickcart.js": "./scripts/hooks/Cartfinity/quickcart.js",
	"./quickeditHook.js": "./scripts/hooks/Cartfinity/quickeditHook.js",
	"./quickscan.js": "./scripts/hooks/Cartfinity/quickscan.js",
	"./salesOrderHook.js": "./scripts/hooks/Cartfinity/salesOrderHook.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./scripts/hooks/Cartfinity sync recursive \\.js$/";